import { useTranslation } from "react-i18next";

import LiveSessionCard from "@/domains/certifications/components/LiveSessionCard";
import { LiveSessionsProps } from "@/features/certifications/overview/components/types";

import "./styles.css";

const LiveSessions = ({ sessions }: LiveSessionsProps) => {
  const { t } = useTranslation();

  if (sessions.length === 0) return null;

  return (
    <section className="flex flex-col gap-400">
      <div className="flex flex-wrap items-end justify-between gap-200">
        <h2 className="certification-heading header-l-medium">
          {t("certification.labels.liveSessions.title")}
        </h2>

        <p className="certification-muted body-xs-regular">
          {t("certification.labels.liveSessions.note")}
        </p>
      </div>

      <div className="certification-card-row flex flex-wrap gap-300">
        {sessions.map((session) => (
          <LiveSessionCard key={session.id} session={session} />
        ))}
      </div>
    </section>
  );
};

export default LiveSessions;
